// Notas, post-its e setas (migração 0007). Espelham dom_tipo_nota, dom_visibilidade e dom_tipo_alvo.

export enum TipoNota {
  DoProcesso = 1,
  Geral = 2,
  PostIt = 3,
  Texto = 4,
}

export enum Visibilidade {
  Privada = 1,
  Compartilhada = 2,
  Publica = 3,
}

export enum TipoAlvo {
  Processo = 1,
  Nota = 2,
  Grupo = 3,
  // Dentro da licitação (migração 0008): módulo e itens dos módulos.
  Modulo = 4,
  Documento = 5,
  Atividade = 6,
  Pessoa = 7,
}

export const DOMINIOS_NOTAS: { nome: string; tabela: string; descricoes: Record<number, string> }[] = [
  {
    nome: 'TipoNota',
    tabela: 'dom_tipo_nota',
    descricoes: {
      [TipoNota.DoProcesso]: 'Do processo',
      [TipoNota.Geral]: 'Geral',
      [TipoNota.PostIt]: 'Post-it',
      [TipoNota.Texto]: 'Texto',
    },
  },
  {
    nome: 'Visibilidade',
    tabela: 'dom_visibilidade',
    descricoes: {
      [Visibilidade.Privada]: 'Privada',
      [Visibilidade.Compartilhada]: 'Compartilhada',
      [Visibilidade.Publica]: 'Pública',
    },
  },
  {
    nome: 'TipoAlvo',
    tabela: 'dom_tipo_alvo',
    descricoes: {
      [TipoAlvo.Processo]: 'Processo',
      [TipoAlvo.Nota]: 'Nota',
      [TipoAlvo.Grupo]: 'Grupo',
      [TipoAlvo.Modulo]: 'Módulo da licitação',
      [TipoAlvo.Documento]: 'Documento',
      [TipoAlvo.Atividade]: 'Atividade ou marco',
      [TipoAlvo.Pessoa]: 'Pessoa da licitação',
    },
  },
];
